import React from "react";
import "../styles/GuidedLearner.css";

const PeakPrep = ({ features, limitations }) => {
  return (
    <div className="GuidedLearner">
      <div className="fw700">Annual Plan - “Ultimate Top Performer Prep”</div>
      <div className="collections">
        <div className="collection1">
          <div className="info">
            <span className="fw700">Price:</span> $187.5 per year (one-time or annually recurring, ($250 – 25% Discount))
          </div>
          <div className="info">
            <span className="fw700">Target Audience:</span> Students who want sustained preparation and long-term access, including high school juniors preparing months in advance
          </div>
        </div>

        <div className="collection2">
          <div className="section-title">Features</div>
          {features && features.length > 0 ? (
            features.map((feature, index) => {
              const [title, text] = feature.split(":");
              return (
                <div key={index} className="feature">
                  <span className="fw700">{title}:</span> {text}
                </div>
              );
            })
          ) : (
            <div className="feature">No features available.</div>
          )}
        </div>

        <div className="collection3">
          <div className="limitations">
            <span className="fw700">Limitations:</span> {limitations}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeakPrep;
